import { EventAttendanceInterface } from '@/services/Calendar/EventAttendance/Interfaces';

export default interface EventsRepositoryInterface {
  getEventsForCurrentMonth(): Promise<EventsInterface[]>

  getEvent(id: number): Promise<EventsInterface>

  getEventsFromRangeOfDates(start: Date, end: Date): Promise<EventsInterface[]>

  getEventsForMonth(year: number, month: number): Promise<EventsInterface[]>

  getEventsForQuarter(year: number, quarter: number): Promise<EventsInterface[]>

  getEventsForYear(year: number): Promise<EventsInterface[]>

  createEvent(data: CreateEventsInterface): Promise<EventsInterface>

  updateEvent(data: UpdateEventsInterface): Promise<void>

  deleteEvent(id: number): Promise<void>
}

export enum EventType {
  national = 0,
  custom = 1,
}

export interface EventsInterface {
  id: number;
  type: EventType;
  name: string;
  description: string;
  location?: string;
  author?: string;
  date: Date;
  signUpEndDate: Date;
  attendanceLimit: number;
}

export interface CreateEventsInterface {
  type: EventType;
  name: string;
  description: string;
  location?: string;
  author?: string;
  date: Date;
  signUpEndDate?: Date;
  attendanceLimit?: number;
}

export interface UpdateEventsInterface extends CreateEventsInterface {
  id: number;
}
